import * as types from 'src/store/mutation-types'
import { PersonClient } from 'src/api/Persons'

const actions = {
  createPerson ({ commit }, person) {
    return new PersonClient()
      .create(person)
      .then(person => {
        person = person.data.data
        person.type = 'person'
        commit(types.ADD_CUSTOMER, person)
        return person
      })
  },

  updatePerson ({ commit }, data) {
    return new PersonClient()
      .include(['default_email_address', 'default_phone_number', 'company'])
      .update(data.id, data)
      .then(person => {
        person = person.data.data
        person.type = 'person'
        commit(types.UPDATE_CUSTOMER, person)
        return person
      })
  }
}

export default {
  actions
}
